import * as Yup from 'yup';

// Схема для валидации имени
export const validationSchema = Yup.object({
  name: Yup.string().required('Заполните поле'),
});
